// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranquiasBackfill_PaisToIsoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /cli/Franquias_backfill/pais_to_iso
 *
 * Triggers the S1b franquias.pais free-text -> ISO 3166-1 alpha-2 backfill.
 * Protected by X-Internal-Token — no user JWT required (same posture as
 * SubscriptionBackfill_RunInput).
 *
 * default 'dry-run': a POST without a body NEVER writes.
 */
import { registerContract } from './validate'

export interface FranquiasBackfill_PaisToIsoInput {
mode?: string
}

registerContract('FranquiasBackfill_PaisToIsoInput', {
  mode: { type: 'string',  required: false },
})
